<template lang="pug">
    div
      div.collapsible-header
        i.material-icons store
        | Shops
      .row
        .col.s12.right-align
          a.btn.btn-flat(@click='showAddShop') 
            i.material-icons.left add
            | Add
      ul.collection
        a.collection-item(href='#', v-for='shop in shops' @click='showShop(shop)')
          .row.nomargin
            .col.s12.m8
              p.no-margin.title.small {{shop.name}}
              p.no-margin.subtitle.micro {{shop.location}}
            .col.s12.m4.right-align
              a.btn.btn-flat(href='#' @click.stop='showRemoveShop(shop)')
                i.material-icons delete
</template>
<script>
import ModalAddSupplierShop from '@/components/modal-add-supplier-shop'
import ModalRemoveSupplierShop from '@/components/modal-remove-supplier-shop'

export default {
  props: ['supplier'],
  data () {
    return {
      modalContent: null,
      shops: []
    }
  },
  mounted () {
    this.getCurrentShops()
  },
  methods: {
    showShop (shop) {
      const modalParams = {
        content: ModalAddSupplierShop,
        bind: {
          supplierId: this.supplier.id,
          shop: shop,
          onAddSuccess: (shop) => {
            this.getCurrentShops()
            this.$store.dispatch('modal/close')
            this.$snackbar.success('Shop saved')
          },
          onAddError: (err) => {
            this.$store.dispatch('modal/close')
            this.$snackbar.error(`Unable to add shop: ${err.message}`)
          }
        },
        style: {
          padding: 'medium'
        }
      }

      this.$store.dispatch('modal/open', modalParams)
    },
    showAddShop () {
      this.showShop(null)
    },
    showRemoveShop (shop) {
      const modalParams = {
        content: ModalRemoveSupplierShop,
        bind: {
          supplierId: this.supplier.id,
          shop: shop,
          onRemoveSuccess: (shop) => {
            this.getCurrentShops()
            this.$store.dispatch('modal/close')
            this.$snackbar.success('Shop removed')
          },
          onRemoveError: (err) => {
            this.$store.dispatch('modal/close')
            this.$snackbar.error(`Unable to remove shop: ${err.message}`)
          },
          onRemoveCancelled: () => {
            this.$store.dispatch('modal/close')
          }
        },
        style: {
          padding: 'medium'
        }
      }

      this.$store.dispatch('modal/open', modalParams)
    },
    getCurrentShops () {
      return this.$store.dispatch('auth/getAccessToken').then(accessToken => {
        return this.$http
          .get(`${this.$config.API_URL}/suppliers/${this.supplier.id}/shops`, {
            headers: {
              authorization: `Bearer ${accessToken}`
            }
          })
          .then(result => {
            this.shops = result.data
          })
      })
    }
  }
}
</script>


// WEBPACK FOOTER //
// src/components/app-supplier-shops.vue